/**
 * usePreviousPayModal Hook
 * Manages previous pay comparison modal state
 */

import { useState, useCallback } from 'react';

/**
 * Custom hook for managing previous pay modal
 * @returns {Object} { showModal, openModal, closeModal, toggleModal }
 */
export const usePreviousPayModal = () => {
  const [showModal, setShowModal] = useState(false);

  /**
   * Open the modal
   */
  const openModal = useCallback(() => {
    setShowModal(true);
  }, []);

  /**
   * Close the modal
   */
  const closeModal = useCallback(() => {
    setShowModal(false);
  }, []);

  /**
   * Toggle modal visibility
   */
  const toggleModal = useCallback(() => {
    setShowModal(prev => !prev);
  }, []);

  return {
    showModal,
    openModal,
    closeModal,
    toggleModal
  };
};
